import { render, staticRenderFns } from "./AcademicPlan.vue?vue&type=template&id=f51f7f08&"
import script from "./AcademicPlan.vue?vue&type=script&lang=js&"
export * from "./AcademicPlan.vue?vue&type=script&lang=js&"
import style0 from "./AcademicPlan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports